
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const LinkAdd20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5ZM18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.44 4.43c.3.13.6.29.88.47.3-.56.48-1.21.48-1.9Zm-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1Zm5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
            fill="currentColor"
        />
    </svg>
}